import PropTypes from 'prop-types';
import { inventoryWarehouseTypes } from '../constants';

export default PropTypes.shape({
  name: PropTypes.string,
  warehouseType: PropTypes.oneOf([inventoryWarehouseTypes.aggregate, inventoryWarehouseTypes.individual]),
  inventorySourceId: PropTypes.string,
  inventorySourceExternalId: PropTypes.string,
});
